import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AngularMaterialModule, UiComponentModule} from '@rbaip/ui-component';
import {UsageComponent} from './equipment-fields/usage/usage.component';
import {EquipmentDecomponentizationActionComponent} from './equipment-componentization/equipment-decomponentization-action/equipment-decomponentization-action.component';
import {EquipmentComponentizationActionComponent} from './equipment-componentization/equipment-componentization-action/equipment-componentization-action.component';
import {EquipmentComponentizationFormDialogComponent} from './equipment-componentization/equipment-componentization-form-dialog/equipment-componentization-form-dialog.component';
import {EquipmentDecomponentizationFormDialogComponent} from './equipment-componentization/equipment-decomponentization-form-dialog/equipment-decomponentization-form-dialog.component';
import {FlexLayoutModule} from '@angular/flex-layout';

@NgModule({
  declarations: [
    UsageComponent,
    EquipmentComponentizationActionComponent,
    EquipmentComponentizationFormDialogComponent,
    EquipmentDecomponentizationActionComponent,
    EquipmentDecomponentizationFormDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiComponentModule,
    AngularMaterialModule,
    FlexLayoutModule
  ],
  exports: [
    UsageComponent,
    EquipmentComponentizationActionComponent,
    EquipmentDecomponentizationActionComponent
  ],
  entryComponents: []
})
export class ItemSummaryEquipmentCoreModule { }
